import { defineComponent as _defineComponent } from 'vue'
import { injectParentValidator } from '@/core/app.service';
import { computed, ref } from 'vue';
import dictionaryService from '@/core/dictionary.service';
import PdfUpload from '@/ui/shared/imageupload/PdfUpload.vue';
import ImageUploadService from '@/ui/shared/imageupload/image-upload.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReceiptUpload',
  props: {
    receipt: null
  },
  emits: ['on-edit-receipt'],
  setup(__props: any, { emit }) {

const props = __props as {
    receipt?: CarouselImageWithExtension
}




const receiptPreview = ref<CarouselImageWithExtension>(null);
const receiptZoomEnabled = ref<boolean>(false);
const receiptUploadFile = ref(null);

setLoadedPreviewReceipt(props.receipt);

const $validator = injectParentValidator();
$validator.extend(
    'receipt_filesize', {
        getMessage: _ => dictionaryService.get('Pages.ProductRegistration.RegisterProductDetailsPage.ReceiptFileSizeErrorMessage'),
        validate: _ => {
            return receiptUploadFile.value.files[0].size < 3 * 1024 * 1024;
        }
    });

function setLoadedPreviewReceipt(value?: CarouselImageWithExtension) {
    if (props.receipt) {
        receiptPreview.value = value;
        emit('on-edit-receipt', receiptPreview.value);
    }
}

function clickReceiptUpload() {
    (receiptUploadFile.value as any).click();
}

function addReceipt() {
    const input = receiptUploadFile.value;
    if (!input.files.length) {
        return;
    }
    const reader = new FileReader();
    const file = input.files[0];
    reader.onload = (e) => {
        receiptPreview.value = ImageUploadService.mapForUpload(file, e.target.result);
        setLoadedPreviewReceipt(receiptPreview.value);
    };
    reader.readAsDataURL(file);
}

const isPdf = computed<boolean>(() => ImageUploadService.isPdf(receiptPreview.value));

function deleteReceipt() {
    receiptUploadFile.value.files = new DataTransfer().files;
    receiptPreview.value = null;
    setLoadedPreviewReceipt(null);
}

return { __sfc: true,props, emit, receiptPreview, receiptZoomEnabled, receiptUploadFile, $validator, setLoadedPreviewReceipt, clickReceiptUpload, addReceipt, isPdf, deleteReceipt, PdfUpload }
}

})